import { API, Product } from "@thenounproject/lingo-core";
import { createQueryAction } from "@actions/actionCreators";

type Args = {
  spaceId: number;
  uuid: string;
};

const [useProduct, fetchProduct] = createQueryAction<Args, Product, string>(
  {
    entity: "products",
    action: "fetchProduct",
    condition: ({ args }) => Boolean(args.spaceId && args.uuid),
    denormalize: { productType: "productTypes" },
    prefetchData: ({ args }, { getState }) => {
      const product = getState().entities.products.objects[args.uuid];
      return {
        result: product.uuid,
        entities: { products: { [product.uuid]: product } },
      };
    },
  },
  async ({ args }) => {
    const res = await API.call<{ product: string }>({
      endpoint: `spaces/${args.spaceId}/products/${args.uuid}`,
      method: "GET",
    });
    return { ...res, result: res.result.product };
  }
);

export default useProduct;
export { fetchProduct };
